import axios from "axios";
import TR from './../Trans';
import { Capacitor } from '@capacitor/core';
import { CapacitorHttp } from '@capacitor/core';
import muvikaAttrs from './../attrs';
import sessionStore from "../stores/session";
import messageStore from '../stores/message';

const muvikaUrl = muvikaAttrs.apiUrl;
const networkErrorCode = 445566;

class MuvikaHttpClient {

  get(url, parameters) {
    const options = {
      method: "GET",
      url: muvikaUrl,
      headers: {
        "Content-type": "application/x-www-form-urlencoded",
      },
      params: parameters.params,
      responseType: "json"
    };

    return CapacitorHttp.request(options)
      .then(response => {
        messageStore.setState({lastShown: null});
        return response
      })
      .catch(error => {
        if (error.status) {
          console.error('HTTP error:', error.status, error.data);
        } else if (error.message) {
          messageStore.getState().setError(sessionStore.getState().sessionToken, networkErrorCode, TR.cm_network_connection_error);
        } else {
          console.error('Unknown error:', error);
        }

        return Promise.reject(error);
      });

    //return CapacitorHttp.get(options);
  }

  post(url, parameters) {
    const encoded = new URLSearchParams(parameters).toString();
    const options = {
      method: "POST",
      url: muvikaUrl,
      headers: {
        "Content-type": "application/x-www-form-urlencoded",
      },
      data: encoded,
      responseType: "json"
    };

    return CapacitorHttp.request(options)
      .then(response => {
        messageStore.setState({lastShown: null});
        return response
      })
      .catch(error => {
        if (error.status) {
          console.error('HTTP error:', error.status, error.data);
        } else if (error.message) {
          messageStore.getState().setError(sessionStore.getState().sessionToken, networkErrorCode, TR.cm_network_connection_error);
        } else {
          console.error('Unknown error:', error);
        }

        return Promise.reject(error);
      });

    //return CapacitorHttp.get(options);
  }

}

var httpClient;

if (Capacitor.isNativePlatform()) {
  httpClient = new MuvikaHttpClient();
} else {
  httpClient = axios.create({
    baseURL: muvikaUrl,
    headers: {
      "Content-type": "application/x-www-form-urlencoded"
    }
  });
  httpClient.interceptors.response.use(
    response => {
      messageStore.setState({lastShown: null});
      return response
    },
    error => {
      if (error.response) {
        console.error('Server error:', error.response.status);
      } else if (error.request) {
        messageStore.getState().setError(sessionStore.getState().sessionToken, networkErrorCode, TR.cm_network_connection_error);
      } else {
        console.error('Other error:', error.message);
      }

      // Always reject so your app can handle it too
      return Promise.reject(error);
    }
  );
}

export default httpClient;